// import React, { useEffect } from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import "./../../assets/css/TravelSection.css";
// import {
//   FaBed,
//   FaBus,
//   FaPlaneDeparture,
//   FaRoute,
//   FaUserTie,
// } from "react-icons/fa6";
// import { PiBowlFood } from "react-icons/pi";

// const TravelSection = () => {
//   useEffect(() => {
//     // Animation for cards on scroll
//     const handleScroll = () => {
//       const featureCards = document.querySelectorAll(".feature-card");

//       featureCards.forEach((card) => {
//         const cardTop = card.getBoundingClientRect().top;
//         const windowHeight = window.innerHeight;

//         if (cardTop < windowHeight - 100) {
//           card.classList.add("visible");
//         }
//       });
//     };

//     window.addEventListener("scroll", handleScroll);
//     // Initial check on component mount
//     handleScroll();

//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <section id="travelSection" className="travel-section">
//       <Container>
//         <h1 className="section-title" style={{color:"#fff"}}>
//           All Inclusive Tours, Chalo Bag Bharo Nikal Pado!
//         </h1>
//         <Row>
//           {/* Accommodation */}
//           <Col md={4} sm={6} className="feature-col">
//             <div className="feature-card">
//               <div className="icon-wrapper">
//                 <FaBed className="feature-icon" />
//               </div>
//               <h3 className="feature-title">Accommodation</h3>
//               <p className="feature-text">
//                 Comfortable & convenient hotels cherry-picked by our hotel
//                 management team.
//               </p>
//             </div>
//           </Col>

//           {/* All Meals */}
//           <Col md={4} sm={6} className="feature-col">
//             <div className="feature-card">
//               <div className="icon-wrapper">
//                 <PiBowlFood className="feature-icon" />
//               </div>
//               <h3 className="feature-title">All Meals</h3>
//               <p className="feature-text">
//                 Eat to your heart's content: Breakfast, Lunch, Dinner.
//               </p>
//             </div>
//           </Col>

//           {/* On-Tour Transport */}
//           <Col md={4} sm={6} className="feature-col">
//             <div className="feature-card">
//               <div className="icon-wrapper">
//                 <div className="custom-icon-wrapper">
//                   <FaBus className="feature-icon" />
//                 </div>
//               </div>
//               <h3 className="feature-title">On-Tour Transport</h3>
//               <p className="feature-text">
//                 Our itineraries include all rail, sea, and road transport as
//                 part of the itinerary so you can enjoy tension-free travel.
//               </p>
//             </div>
//           </Col>

//           {/* Tour Managers */}
//           <Col md={4} sm={6} className="feature-col">
//             <div className="feature-card">
//               <div className="icon-wrapper">
//                 <FaUserTie className="feature-icon" />
//               </div>
//               <h3 className="feature-title">Tour Managers</h3>
//               <p className="feature-text">
//                 We have an exclusive team of 350 tour managers specializing in
//                 India and World tours.
//               </p>
//             </div>
//           </Col>

//           {/* Best Value Itinerary */}
//           <Col md={4} sm={6} className="feature-col">
//             <div className="feature-card">
//               <div className="icon-wrapper">
//                 <FaRoute className="feature-icon" />
//               </div>
//               <h3 className="feature-title">Best Value Itinerary</h3>
//               <p className="feature-text">
//                 Our dedicated product & destination research team spends hours
//                 curating the best value-for-money itineraries.
//               </p>
//             </div>
//           </Col>

//           {/* To and Fro Airfare */}
//           <Col md={4} sm={6} className="feature-col">
//             <div className="feature-card">
//               <div className="icon-wrapper">
//                 <FaPlaneDeparture className="feature-icon" />
//               </div>
//               <h3 className="feature-title">To and Fro Airfare</h3>
//               <p className="feature-text">
//                 Veena World tours are inclusive of airfare from many hubs within
//                 India unless you pick the joining-leaving option.
//               </p>
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </section>
//   );
// };

// export default TravelSection;


import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./../../assets/css/TravelSection.css";
import {
  FaBed,
  FaBus,
  FaRoute,
  FaUserTie,
  FaHandsPraying,
  FaUtensils,
} from "react-icons/fa6";

const TravelSection = () => {
  useEffect(() => {
    const handleScroll = () => {
      const featureCards = document.querySelectorAll(".feature-card");
      featureCards.forEach((card) => {
        const cardTop = card.getBoundingClientRect().top;
        if (cardTop < window.innerHeight - 100) {
          card.classList.add("visible");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const features = [
    {
      icon: <FaBed />,
      title: "Handpicked Accommodation",
      text: "Comfortable hotels selected for location, hygiene, and guest comfort, close to temples and major attractions.",
    },
    {
      icon: <FaUtensils />,
      title: "Meals Included",
      text: "Pure vegetarian meals freshly cooked by our own experienced Maharaj, ensuring taste and hygiene throughout.",
    },
    {
      icon: <FaBus />,
      title: "On-Tour Transportation",
      text: "Well-maintained vehicles with experienced drivers ensuring safe and smooth travel across all terrains.",
    },
    {
      icon: <FaUserTie />,
      title: "Dedicated Tour Manager",
      text: "Experienced managers assisting guests throughout the tour, including check-ins and darshan coordination.",
    },
    {
      icon: <FaRoute />,
      title: "Expertly Curated Itineraries",
      text: "Thoughtfully planned routes ensuring proper rest, acclimatization, and a stress-free pilgrimage experience.",
    },
    {
      icon: <FaHandsPraying />,
      title: "Pilgrimage Specialists",
      text: "Serving travelers since 1940 with expertise in Char Dham, Jyotirlingas, and International spiritual tours.",
    },
  ];

  return (
    <section id="travelSection" className="travel-section">
      <Container>
        <div className="text-center mb-5">
          <h1 className="section-main-title text-white">All-Inclusive Journeys, Since 1940</h1>
          <p className="text-white">Curated tours with comfort, care & legacy by Radheshyam Travels</p>
          <div className="title-underline"></div>
        </div>

        <Row className="g-4">
          {features.map((item, index) => (
            <Col lg={4} md={6} key={index} className="feature-col">
              <div className="feature-card">
                <div className="card-inner">
                  <div className="icon-wrapper">
                    <div className="feature-icon">{item.icon}</div>
                    <div className="rotating-border"></div>
                  </div>
                  <h3 className="feature-title">{item.title}</h3>
                  <p className="feature-text">{item.text}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default TravelSection;